import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	repositoryListTitle: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list-title',
		defaultMessage: 'Latest repositories',
		description: 'The title of the repository list. Repository is the code repository.',
	},
	repositoryListDescription: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list-description',
		defaultMessage:
			'The most recent repositories with commits, branches, or pull requests linked to this project.',
		description:
			'The description of the repository list when at least one repository is available.',
	},
	repositoriesErrorStateTitle: {
		id: 'software-code-code-page.pages.main-page.repositories.repositories-error-state-title',
		defaultMessage: 'We couldn’t load your repositories',
		description:
			'The title used shown when a error occurs in the repo list. Lets the user know something went wrong.',
	},
});
